/**
 * Euchre trump + maker indicator. Floats top-right of the game view in
 * the same slot the other games' compact trump badges use.
 *
 * Shows the trump suit, with a small "Alone" / "Maker" tag below for
 * additional context. Hidden until trump is set (bidding phase).
 */

import type { EuchrePublicState } from "../../../../shared/games/euchre.js";
import { TrumpBadge } from "../../components/TrumpBadge.js";

export function EuchreTrumpPanel({ state }: { state: EuchrePublicState }) {
  const suit = state.trumpSuit;
  if (!suit) return null;
  // Show "Alone" when the maker went alone; otherwise show "Maker" so
  // the team that's at risk is clear at a glance.
  const label = state.alone ? "Alone" : "Maker";
  return <TrumpBadge suit={suit} suitLabel={label} />;
}
